import React from "react";
import styles from "./AboutPage.module.scss";

export default function AboutPage() {
  const heroTitle = "Welcome.";
  const heroSubtitle = "Psychology Student and Performance Strategy Consultant";
  const closingPhrase =
    "Most of the time, it is not failure.It is a foundation problem.";

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Tom Alvarez",
    description:
      "Tom Alvarez works at the intersection of psychology, performance, and business execution, helping individuals and organizations build structure, clarity, and measurable progress.",
    url: "https://relentlessminds.com/about",
    knowsAbout: [
      "Industrial-Organizational Psychology",
      "Performance Psychology",
      "Behavior Change",
      "Leadership Development",
      "Career Transition Coaching",
      "Organizational Performance",
      "Business Execution",
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      <div className={styles.page}>
        <section className={styles.heroBanner}>
          <div className={styles.heroInner}>
            <p className={`${styles.eyebrow} t-caption`}>About Me</p>
            <h1 className={`${styles.heroTitle} t-display-title`}>
              {heroTitle}
            </h1>
            <p className={`${styles.heroSubtitle} t-h4`}>{heroSubtitle}</p>
          </div>
        </section>

        <div className={`${styles.content} grid`}>
          <main className={styles.main}>
            <section className={styles.introSection}>
              <article className={`${styles.article} article-body`}>
                <h2 className={`${styles.statement} t-h1`}>
                  Giving up has never been an option.
                </h2>
                <p>
                  For a long time, I lived on autopilot.
                  <br />
                  I was the kind of person who complained about life more than I
                  changed it. I felt stuck in my own patterns, held back by
                  self-doubt, frustration, and the quiet lies we tell ourselves
                  when we stop believing change is possible. On the outside,
                  life kept moving. On the inside, I knew I was not becoming the
                  person I was meant to be.
                  <br />
                  <br />
                  Then something shifted.
                </p>
                <p>
                  I got tired of waiting for life to change on its own. I got
                  tired of circling the same thoughts, the same excuses, and the
                  same internal barriers. I made the decision to face myself
                  honestly. That meant confronting my inner critic, accepting
                  where I was, and taking responsibility for where I wanted to
                  go next.{" "}
                </p>
                <p>
                  That decision changed everything. When I lost my job in tech,
                  it could have been another setback that defined me. Instead,
                  it became a turning point. I chose to pursue a degree in
                  psychology, and through that process I found something deeper
                  than a career path. I found purpose. I realized that my real
                  passion was helping people break through the same mental
                  blocks that once kept me stuck.
                </p>
                <p>
                  Even thoough there are times when I still struggle with the
                  same patterns, I am no longer defined by them. I am defined by
                  the choice to keep moving forward, to keep learning, and to
                  keep building a life that reflects my values and my potential.
                  That is what being relentless really means.
                </p>
                <p>
                  The never ending pursuit to improve myself is a journey that I
                  will always be on. I dont consider myself perfect but I am
                  committed to growth. These lessons have taught me that true
                  transformation is not about perfection, but about progress. In
                  that progress I will find myself along the way and that is
                  what I hope for you too. Together, we will look at the big
                  picture of your life to create a plan that fits your schedule,
                  your strengths, and your goals.
                </p>
              </article>
            </section>{" "}
            <section className={styles.closingSection}>
              <article className={`${styles.article} article-body`}>
                <h2 className={`${styles.sectionHeaderClass} t-h2`}>
                  My Mission
                </h2>
                <p>
                  I help people stop living on autopilot and start living with
                  intention.
                </p>
                <p>
                  Through wellness coaching, mindset coaching, and behavior
                  change strategies, I work with people who are ready to rebuild
                  their energy, strengthen their habits, and create a healthier,
                  more aligned life. This is not about perfection. It is about
                  becoming more honest, more disciplined, and more resilient
                  over time. These are the things that have been helping me on
                  my own journey, and they are the things I want to share with
                  you.
                </p>
              </article>
            </section>
            <section className={styles.pullQuoteWrapper}>
              <blockquote className={styles.pullQuote}>
                {closingPhrase}
              </blockquote>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}
